<template>
<layout-content :title="`${editName}管理`">
  <template #toolbar>
    <section class="toolbar-btn">
      <el-radio-group v-model="radio" size="small" @change="pageChange">
        <el-radio-button :label="1">站房仪器因子</el-radio-button>
        <el-radio-button :label="2">站房仪器状态</el-radio-button>
      </el-radio-group>
      <el-button
        type="primary"
        size="small"
        @click="showFull"
      >{{flag ? '返回' : '全屏'}}</el-button>
      <el-button
        v-if="isAdmin || orgTypeId === 1"
        :disabled="!siteDevice.id"
        type="orange"
        icon="el-icon-plus"
        size="small"
        @click="onCreateBtnClick"
      >新建{{editName}}</el-button>
    </section>
  </template>

  <template #body>
    <el-table
      v-if="radio === 1"
      ref="table"
      :data="list"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      style="width: 100%"
      @selection-change="onSelectionChange"
      @row-click="onOpenEditor"
    >
      <el-table-column label="序号" width="50" fixed>
        <template slot-scope="{$index}">{{$index + 1}}</template>
      </el-table-column>

      <el-table-column label="因子名称" fixed width="170">
        <template slot-scope="{row}">{{(factorMap[row.factorId] || {}).displayName}}</template>
      </el-table-column>

      <el-table-column label="修正范围" width="150">
        <template slot-scope="{row}">{{Number.isFinite(row.amendLowRange) ? row.amendLowRange : '--'}} ~ {{Number.isFinite(row.amendHighRange) ? row.amendHighRange : '--'}}</template>
      </el-table-column>

      <el-table-column prop="amendValue" label="修正值" />

      <el-table-column label="超标范围">
        <template slot-scope="{row}">{{Number.isFinite(row.limitLow) ? row.limitLow : '--'}} ~ {{Number.isFinite(row.limitHigh) ? row.limitHigh : '--'}}</template>
      </el-table-column>

      <el-table-column label="是否报警" align="center" width="80">
        <template slot-scope="{row}">
          <my-switch
            v-model="row.isAlarm"
            @click.native.stop
            @change="onChangeIsAlarm(row, ...arguments)"
          />
        </template>
      </el-table-column>

      <el-table-column label="报警范围" width="150">
        <template slot-scope="{row}">{{Number.isFinite(row.alarmMin) ? row.alarmMin : '--'}} ~ {{Number.isFinite(row.alarmMax) ? row.alarmMax : '--'}}</template>
      </el-table-column>

      <el-table-column label="是否启用" align="center" width="80">
        <template slot-scope="{row}">
          <my-switch
            v-model="row.status"
            @click.native.stop
            @change="onChangeStatus(row, ...arguments)"
          />
        </template>
      </el-table-column>
    </el-table>

    <el-table
      v-if="radio === 2"
      ref="table"
      :data="list"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      style="width: 100%"
      @selection-change="onSelectionChange"
      @row-click="onOpenEditor"
    >
      <el-table-column label="序号" width="50" fixed>
        <template slot-scope="{$index}">{{$index + 1}}</template>
      </el-table-column>

      <el-table-column prop="statusName" label="状态名称" fixed width="170">
        <template slot-scope="{row}">{{row.statusName}}</template>
      </el-table-column>

      <el-table-column label="是否报警" align="center" width="80">
        <template slot-scope="{row}">
          <my-switch
            v-model="row.isAlarm"
            @click.native.stop
            @change="onChangeIsAlarm(row, ...arguments)"
          />
        </template>
      </el-table-column>

      <el-table-column label="报警范围">
        <template slot-scope="{row}">
          {{Number.isFinite(row.alarmMin) ? row.alarmMin : '--'}} ~ {{Number.isFinite(row.alarmMax) ? row.alarmMax : '--'}}
        </template>
      </el-table-column>

      <el-table-column label="关键参数" align="center" width="80">
        <template slot-scope="{row}">
          <my-switch
            v-model="row.isImportance"
            @click.native.stop
            @change="onChangeIsImportance(row, ...arguments)"
          />
        </template>
      </el-table-column>

      <el-table-column label="是否启用" align="center" width="80">
        <template slot-scope="{row}">
          <my-switch
            v-model="row.status"
            @click.native.stop
            @change="onChangeStatus(row, ...arguments)"
          />
        </template>
      </el-table-column>
    </el-table>
  </template>

  <template #editor>
    <site-device-factor-creator
      ref="creator"
      :site-device="siteDevice"
      :site-device-factors="list"
      :radio="radio"
      :device-status-map="deviceStatusMap"
      @save="getList"
    />
    <site-device-factor-editor
      ref="editor"
      :site-device="siteDevice"
      :radio="radio"
      :device-status-map="deviceStatusMap"
      @save="getList"
      @close="onCancelHighlightTableRow"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../BaseListEditor'
import SiteDeviceFactorEditor from './SiteDeviceFactorEditor'
import SiteDeviceFactorCreator from './SiteDeviceFactorCreator'
import {mapGetters} from 'vuex'

export default {
  name: 'SiteDeviceFactorListEditor',
  extends: BaseListEditor,
  components: {SiteDeviceFactorCreator, SiteDeviceFactorEditor},
  props: {
    siteDevice: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      flag: false,
      radio: 1,
      deviceStatusMap: {}
    }
  },
  computed: {
    ...mapGetters({
      orgTypeId: 'Profile/orgTypeId'
    }),
    apiKey () {
      return this.radio === 1 ? 'SiteDeviceFactor' : 'SiteDeviceStatus'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return 'name'
    },
    editName () {
      return this.radio === 1 ? '站房仪器因子' : '站房仪器状态'
    }
  },
  methods: {
    pageChange () {
      this.getList()
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    showFull () {
      this.flag = !this.flag
      this.$eventBus.emit('setShowFullFlag', this.flag ? 3 : 0)
    },
    onSiteDeviceSelectChanged (siteDevice) {
      let {id: siteDeviceId} = siteDevice

      if (!siteDeviceId) {
        this.list = []
        return
      }

      this.query.siteDeviceId = siteDeviceId
      this.getList()
    },
    setList (list) {
      this.list = list || []
    },
    onChangeIsImportance (data, isImportance) {
      this.changeLoadStatus(true)
      this.$api.SiteDeviceStatus.save(data, 'PUT').then(() => {}).catch(error => {
        console.error(error)
        data.isImportance = !isImportance
      }).finally(() => {
        data = null
        this.changeLoadStatus(false)
      })
    },
    onChangeIsAlarm (siteDeviceFactor, isAlarm) {
      if (isAlarm && (typeof siteDeviceFactor.alarmMin !== 'number' || typeof siteDeviceFactor.alarmMax !== 'number')) {
        this.$notify({
          title: '错误',
          message: '开启失败,未设置告警限值。',
          type: 'error',
          position: 'bottom-right'
        })

        siteDeviceFactor.isAlarm = false
        return
      }

      this.changeLoadStatus(true)
      let {apiKey} = this
      this.$api[apiKey].changeIsAlarm(siteDeviceFactor.id, isAlarm).then(() => {}).catch(error => {
        console.error(error)
        siteDeviceFactor.isAlarm = !isAlarm
      }).finally(() => {
        siteDeviceFactor = null
        this.changeLoadStatus(false)
      })
    },
    onCreateBtnClick () {
      let refEditor = this.$refs.creator
      refEditor && refEditor.open()
    },
    getDeviceStatus () {
      this.changeLoadStatus(true)
      this.$api.DeviceStatus.getList().then(data => {
        this.deviceStatusMap = data.reduce((map, el) => {
          map[el.id] = el

          return map
        }, {})
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  created () {
    this.getDeviceStatus()
  },
  watch: {
    siteDevice: {
      immediate: true,
      handler (siteDevice) {
        if (siteDevice) {
          this.onSiteDeviceSelectChanged(siteDevice)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/SiteDeviceFactorListEditor.vue